import React from 'react';
import PropTypes from 'prop-types';
import { Heading, VisuallyHidden } from '@web/atoms';
import {
  StarRatingRow,
  StyledStarRating,
  ReviewCountLabel,
  SubheadlineContainer,
  DesktopCtaContainer,
  HeadlineWrapper,
  ContentIntro,
} from './styles.js';

export const StoryCardsContent = ({
  starRating,
  headline,
  typography = 'heading1',
  fontColor = 'text.primary',
  subheadline,
  ctaNode,
  backgroundColor = 'background.lightest',
}) => {
  return (
    <>
      <ContentIntro>
        {starRating && (
          <StarRatingRow>
            {starRating.showStars && (
              <StyledStarRating>
                <VisuallyHidden>5 star rating</VisuallyHidden>
              </StyledStarRating>
            )}
            {starRating.reviewCountLabel && (
              <ReviewCountLabel $fontColor={fontColor}>
                {starRating.reviewCountLabel}
              </ReviewCountLabel>
            )}
          </StarRatingRow>
        )}

        {headline && (
          <HeadlineWrapper>
            <Heading
              headingLevel="h2"
              typography={typography}
              headingText={headline}
              backgroundColor={backgroundColor}
              fontColor={fontColor}
              position="center"
              verticalPadding={0}
              horizontalPadding={0}
            />
          </HeadlineWrapper>
        )}

        {subheadline && (
          <SubheadlineContainer $fontColor={fontColor}>
            {subheadline}
          </SubheadlineContainer>
        )}
      </ContentIntro>

      {ctaNode && <DesktopCtaContainer>{ctaNode}</DesktopCtaContainer>}
    </>
  );
};

StoryCardsContent.displayName = 'StoryCardsContent';

StoryCardsContent.propTypes = {
  starRating: PropTypes.shape({
    showStars: PropTypes.bool,
    reviewCountLabel: PropTypes.string,
  }),
  headline: PropTypes.string.isRequired,
  typography: PropTypes.string,
  fontColor: PropTypes.string,
  subheadline: PropTypes.node,
  ctaNode: PropTypes.node,
  backgroundColor: PropTypes.string,
};
